/**
 * Converts a time period string (e.g. "1w", "2w", "3w") to a number of weeks
 * @param periodString The time period string to convert
 * @returns The number of weeks as a number
 * @throws Error if the string format is invalid
 */
export function convertWeekStringToDurationNumber(periodString: string): number {
    const match = periodString.match(/^(\d+)w$/);
    if (!match) {
        throw new Error(`Invalid period string format: ${periodString}. Expected format: "1w", "2w", etc.`);
    }
    return Number.parseInt(match[1], 10);
}

export const getTimeRemaining = (endDate: string, excludeExtra = false) => {
    const end = new Date(endDate).getTime();
    const now = Date.now();
    let diff = end - now;
    if (diff < 0) diff = 0;
    const weeks = Math.floor(diff / (1000 * 60 * 60 * 24 * 7));
    const days = Math.floor((diff % (1000 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    if (excludeExtra) {
        if (hours === 0 && days === 0 && weeks === 0) {
            return `${minutes} minutes`;
        }
        if (days === 0 && weeks === 0) {
            return `${hours} hours, ${minutes} minutes`;
        }
        if (weeks === 0) {
            return `${days} days, ${hours} hours, ${minutes} minutes`;
        }
    }
    return `${weeks} weeks, ${days} days, ${hours} hours, ${minutes} minutes`;
};
